export const formatAmount = (amount: number | string): string => {
  const num = Number(amount);
  return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
};
